import { cn } from "@/lib/utils";

// Consistent status vocabulary + colours across all Brugo modules (light theme).
const S = {
  emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  red: "bg-red-50 text-red-700 border-red-200",
  indigo: "bg-indigo-50 text-indigo-700 border-indigo-200",
  cyan: "bg-cyan-50 text-cyan-700 border-cyan-200",
  sky: "bg-sky-50 text-sky-700 border-sky-200",
  slate: "bg-slate-100 text-slate-600 border-slate-200",
};
const MAP = {
  active: { label: "Active", cls: S.emerald },
  verified: { label: "Verified", cls: S.emerald },
  approved: { label: "Approved", cls: S.emerald },
  onboarding: { label: "Onboarding", cls: S.amber },
  draft: { label: "Draft", cls: S.slate },
  submitted: { label: "Submitted", cls: S.indigo },
  correction: { label: "Correction", cls: S.amber },
  correction_needed: { label: "Correction", cls: S.amber },
  pending_kyc: { label: "Pending KYC", cls: S.amber },
  kyc_review: { label: "KYC Review", cls: S.amber },
  approval_queue: { label: "Approval Queue", cls: S.indigo },
  suspended: { label: "Suspended", cls: S.red },
  flagged: { label: "Flagged", cls: S.red },
  new: { label: "New", cls: S.sky },
  ops_required: { label: "Ops Required", cls: S.amber },
  ready: { label: "Ready", cls: S.emerald },
  leads_released: { label: "Leads Released", cls: S.indigo },
  responding: { label: "Responding", cls: S.cyan },
  no_responses: { label: "No Responses", cls: S.red },
  low_response: { label: "Low Response", cls: S.red },
  on_hold: { label: "On Hold", cls: S.slate },
  matched: { label: "Matched", cls: S.emerald },
  hired: { label: "Hired", cls: S.emerald },
  closed: { label: "Closed", cls: S.slate },
  pending: { label: "Pending", cls: S.amber },
  rejected: { label: "Rejected", cls: S.red },
  expired: { label: "Expired", cls: S.slate },
  in_progress: { label: "In Progress", cls: S.cyan },
  review: { label: "In Review", cls: S.indigo },
  under_review: { label: "Under Review", cls: S.indigo },
  locked: { label: "Locked", cls: S.slate },
  on_track: { label: "On Track", cls: S.emerald },
  at_risk: { label: "At Risk", cls: S.amber },
  delayed: { label: "Delayed", cls: S.red },
  off_track: { label: "Off Track", cls: S.red },
  open: { label: "Open", cls: S.red },
  in_review: { label: "In Review", cls: S.amber },
  resolved: { label: "Resolved", cls: S.emerald },
  captured: { label: "Captured", cls: S.emerald },
  paid: { label: "Paid", cls: S.emerald },
  unpaid: { label: "Unpaid", cls: S.amber },
  due: { label: "Due", cls: S.indigo },
  refunded: { label: "Refunded", cls: S.slate },
  failed: { label: "Failed", cls: S.red },
  pending_approval: { label: "Pending Approval", cls: S.amber },
  sourcing: { label: "Sourcing", cls: S.cyan },
  scheduled: { label: "Scheduled", cls: S.indigo },
  visit_verified: { label: "Visit Verified", cls: S.emerald },
  confirmed: { label: "Confirmed", cls: S.emerald },
  cancelled: { label: "Cancelled", cls: S.red },
  high: { label: "High", cls: S.red },
  medium: { label: "Medium", cls: S.amber },
  low: { label: "Low", cls: S.slate },
  requested: { label: "Requested", cls: S.sky },
  ops_review: { label: "Ops Review", cls: S.amber },
  completed: { label: "Completed", cls: S.emerald },
  released: { label: "Released", cls: S.indigo },
  responded: { label: "Responded", cls: S.cyan },
  awarded: { label: "Awarded", cls: S.emerald },
};

export function StatusBadge({ status, className }) {
  const key = status == null ? "" : String(status);
  const cfg = MAP[key] || { label: key || "—", cls: S.slate };
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize",
        cfg.cls,
        className
      )}
    >
      {cfg.label}
    </span>
  );
}
